import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router';
import { cn } from '@crm/ui';
import { useTenant } from '../tenant/TenantProvider.tsx';
import { allowedNav, BOTTOM_NAV } from './nav.ts';

export function MobileBottomBar() {
  const { t } = useTranslation();
  const { can } = useTenant();
  const navigate = useNavigate();
  const items = allowedNav(BOTTOM_NAV, can);
  const openModule = (to: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(to, { flushSync: true });
  };
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 grid border-t border-slate-200 bg-white pb-[env(safe-area-inset-bottom)] md:hidden"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      aria-label={t('nav.menu')}
    >
      {items.map(({ to, icon: Icon, labelKey, soon }) =>
        soon ? (
          <span key={to} className="flex flex-col items-center gap-0.5 py-2 text-[11px] text-slate-300" aria-disabled title={t('app.soon')}>
            <Icon size={20} aria-hidden />
            {t(labelKey)}
          </span>
        ) : (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            onClick={openModule(to)}
            data-testid={`bottom-nav-${to.replace(/\W+/g, '') || 'home'}`}
            className={({ isActive }) =>
              cn('flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium', isActive ? 'text-brand' : 'text-slate-500')
            }
          >
            <Icon size={20} aria-hidden />
            {t(labelKey)}
          </NavLink>
        ),
      )}
    </nav>
  );
}
